import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const machines = ref([])
const inventory_total_machines = ref(0)
const machine_filters = ref({})
const inventory_filters = ref({})
const filtered_machines = ref([])
const loading = ref(false)

export default function useMachines() {
  const listMachines = async (order_of_service_id) => {
    axios
      .get('/api/machines/all', { params: { order_of_service_id: order_of_service_id } })
      .then(function (response) {
        machines.value = filtered_machines.value = response.data.data
      })
      .catch(function () {})
  }

  const saveMachineApr = async (data) => {
    return axios.post('/api/machines/apr', data)
  }

  const saveAprHRN = async (data) => {
    return axios.post('/api/machines/updateHRN', data)
  }

  const listInventory = async (order_of_service_id, page, per_page, NR = 0) => {
    loading.value = true

    var filters = Object.keys(inventory_filters.value)
      .filter((key) => inventory_filters.value[key])
      .map((key) => ({ [key]: inventory_filters.value[key].toString() }))
      .reduce((result, current) => Object.assign(result, current), {})

    return new Promise((resolve, reject) => {
      axios
        .get('/api/machines/inventory', {
          params: Object.assign(
            {
              order_of_service_id,
              page,
              per_page,
              NR,
            },
            filters,
          ),
        })
        .then(function (response) {
          inventory_total_machines.value = response.data.meta.total
          machines.value = filtered_machines.value = response.data.data
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
        .finally(() => (loading.value = false))
    })
  }

  const getMaxMetrics = async (machineId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/machines/${machineId}/risk-analysis/get-max-metrics`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  const destroyMachine = async (machine, index) => {
    // Correção: recebia só o objeto do equipamento (sem propriedade .index) e
    // fazia machines.value.splice(event.index, 1) — event.index era sempre
    // undefined, o que o JS trata como 0, removendo a PRIMEIRA linha da tabela
    // em vez da que foi realmente excluída. Agora o índice vem explícito de
    // quem chama. Também não tratava erro nenhum (.catch vazio) — se a API
    // retornasse erro, nada acontecia na tela, dando a impressão de que a
    // exclusão simplesmente não funcionava.
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/machines/destroy/' + machine.id)
        .then(function (response) {
          machines.value.splice(index, 1)
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  const toggleSafetySystem = async (safety_system_id, machine_id) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/machines/toggleSafetySystem', {
          safety_system_id: safety_system_id,
          machine_id: machine_id,
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }

  const updateMachineFilters = async () => {
    let filters = toRaw(machine_filters.value)

    filtered_machines.value = machines.value.filter((row) => {
      let machine = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          machine[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  watch(machine_filters.value, () => {
    updateMachineFilters()
  })

  return {
    machines: computed(() => machines.value),
    machine_filters,
    inventory_filters,
    filtered_machines: computed(() => filtered_machines.value),
    inventory_total_machines,
    loading,
    listMachines,
    listInventory,
    destroyMachine,
    toggleSafetySystem,
    updateMachineFilters,
    getMaxMetrics,
    saveMachineApr,
    saveAprHRN,
  }
}
